import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.87889 10.0034L13.8789 1.00342L16.1211 2.99651L9.00693 11L16.1211 19.0034L13.8789 20.9965L5.87889 11.9965C5.3737 11.4282 5.3737 10.5717 5.87889 10.0034Z"
    />
  </svg>
);
